import Loading from "components/common/layout/Loading";
import NotAuthorized from "components/errors/NotAuthorized";
import React, { ReactNode } from "react";
import PermissionStore from "store/PermissionStore";

export default ({
  children,
  showNA
}: {
  children: ReactNode;
  showNA?: boolean;
}) => {
  const { canEditOrgMembers, loading } = PermissionStore.useContainer();

  if (loading) {
    return <Loading />;
  }

  if (canEditOrgMembers) {
    return <>{children}</>;
  }

  if (showNA) {
    return <NotAuthorized />;
  }

  return null;
};
